import { useContext, useEffect, useState } from "react";
import "./DarshanTemple.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import Select from "react-select";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import { customSelectStyles, SelectLanguageOptions } from "../../middlewares/Utils";
import { GetPanditListDataAPI } from "../../ApiServices/PanditList/PanditList";
import TempleCodModal from "../Darshan Booking/TempleCodModal";
// import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import axios from "axios";
import {
  BaseUrl,
  GetPhonePayPaymentLink,
  RazorPayKey,
  RazorPayName,
  RazorPaySecretKey,
} from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import "../../Pages/Stepper Form/stepper.css";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { FaqModuleID, ServiceDiscounts } from "../enum";
import {
  LanguageList,
  PoojaAtTemple,
} from "../../ApiServices/Pooja At Temple/PoojaTempleApi";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";
import CouponModal from "../CouponModal";
const steps = [
  "Booking Details",
  // "Select Pandit",
  "Booking Preview",
  "Payment Status",
];

const PujaAtTempleBookingForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [showCODModal, setShowCODModal] = useState(null);
  const [selectedPandit, setSelectedPandit] = useState(null);
  const [orderID, setOrderID] = useState();
  const [panditSelectionError, setPanditSelectionError] = useState(null);
  const [error, setError] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState(null);
  const [showBookingReviewModal, setShowBookingReviewModal] = useState(null);
  const [panditDataList, setPanditDataList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [temple, setTemple] = useState(null);
  const [findPandit, setFindPandit] = useState(null);
  const [productBookingData, setProductBookingData] = useState({
    PATB_DATE: null,
    PATB_TIME: null,
    languageID: null,
    landmark: null,
    address: null,
    pincode: null,
    city: null,
    state: null,
    needSamagri: "yes",
    needDrySamagri: 'yes',
    needWetSamagri: 'no',
  });
  const [modelRequestData, setModelRequestData] = useState({
    totalPrice: null,
    amountEntered: null,
  });
  const { setLoader } = useContext(LoaderContext);
  const fromDate = dayjs();
  const userID = localStorage.getItem("userID");
  const product = location.state?.product;
  const pujaDetails = location.state?.pujaDetailsData;
  const [languageList, setLanguageList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState({
    CouponCode: null,
    isApplied: false,
    CoupenAmount: 0,
    walletAmount: 0,
    couponCodeID: null
  });

  const [couponAmount, setCouponAmount] = useState(0)
  const [walletAmount, setWalletAmount] = useState(9000)
  const [isWalletApplied, setIsWalletApplied] = useState(false);
  const [couponObj, setCouponObj] = useState({
    userID: userID,
    serviceID: FaqModuleID?.PujaAtTempleBooking,
    subModuleID: [location.state.PAT_ID],
    orderAmount: Math.round(location.state.PAT_PRICE)

  })

  const [razorPayData, setRazorPayData] = useState({
    PB_DATE: null,
    PB_TIME: null,
    PB_LANGAUGE: null,
    PB_SAMAGRI: null,
    PB_PRICE: null,
    PB_SAMAGRIPRICE: null,
    PANDIT_ID: null,
    USER_ID: null,
    REFERENCES_NO: "",
    ADDRESS: null,
    PUJA_ID: null,
    PAYMENT_TYPE: null,
    CONVINIENCE_FEE: null,
    TAX: null,
    EXTRA: null,
    TRANSACTION_ID: "",
    TRANSACTION_AMT: "",
  });



  const totalPrice =
    parseFloat(product?.PUJA_PRICE || 0) +
    (productBookingData.needSamagri === "yes"
      ? parseFloat(location.state?.PAT_SAMAGRIPRICE || 0)
      : 0) +
    parseFloat(product?.DAKSHINA || 0) +
    parseFloat(product?.CONVENIENCE_FEE || 0); //Tax amount

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setAppliedCoupon((prev) => ({
        ...prev, CouponCode: null,
        isApplied: false,
        CoupenAmount: 0,
        walletAmount: 0
      }))
      setIsWalletApplied(false)
      setCurrentStep(currentStep - 1);

    }
  };

  // useEffect(() => {
  //   GetPanditListData();
  // }, [productBookingData?.languageID]);

  useEffect(() => {
    GetLanguageListLookupListData();
    GetUserWalletAmountData()
  }, []);
  useEffect(() => {

    if (isWalletApplied === true && appliedCoupon?.isApplied === false) {
      const minAmount = Math.min(Number(location.state.PAT_PRICE), walletAmount);
      const discountAmount = Math.round(minAmount * 0.5);
      setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }))
      setCouponAmount(discountAmount);
      // setCouponAmount(walletAmount)
    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.CoupenAmount)
      setAppliedCoupon((prev) => ({ ...prev, walletAmount: 0 }))
    } else {
      setCouponAmount(0)
    }

  }, [isWalletApplied, appliedCoupon])
  console.log('isWalletApplied', isWalletApplied, appliedCoupon?.isApplied)

  const GetLanguageListLookupListData = async () => {
    try {
      const response = await LanguageList(); // Ensure it's correctly imported
      console.log("Extracted Language List:", response.DATA); // Debug
      // debugger
      if (response?.ResponseCode === "0") {
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.LANG_ID,
          label: Lang.LANG_NAME,
        }));
        setLanguageList(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };
  //   const GetPanditListData = () => {};
  const GetPanditListData = async () => {
    // debugger;
    try {
      const response = await GetPanditListDataAPI(
        userID,
        3,
        productBookingData?.languageID,
        {
          START: 1,
          END: 10,
          WORD: "None",
          LATITUDE: "20.0086678",
          LONGITUDE: "73.7639264",
        }
      );

      if (response) {
        setPanditDataList(response.DATA);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const HandleProductBookingBtnClicked = () => {
    // debugger;
    let isValid = false;

    if (
      productBookingData.PATB_DATE === null ||
      productBookingData.PATB_DATE === undefined ||
      productBookingData.PATB_DATE === "" ||
      productBookingData.PATB_TIME === null ||
      productBookingData.PATB_TIME === undefined ||
      productBookingData.PATB_TIME === "" ||
      productBookingData.needSamagri === null ||
      productBookingData.needSamagri === undefined ||
      productBookingData.needSamagri === ""
    ) {
      isValid = true;
      setError(true);
    }

    if (!isValid) {
      nextStep();
    }
  };
  const GetUserWalletAmountData = async () => {

    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userID); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setWalletAmount(Number(list[0]?.WalletAmount) <= 0 ? 0 : list[0]?.WalletAmount)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const SGST = 9;
  const CGST = 9;
  const convenienceFee = parseFloat(location?.state?.PAT_CONVENIENCEFEE) || 0; // Ensure it's a number

  // Calculate Dynamic Tax
  const DynamicTax = ((SGST + CGST) / 100) * convenienceFee;

  // Convert all values to numbers
  const brahminDakshina = parseFloat(location?.state?.PAT_PRICE) || 0;
  // const samagriPrice =
  //   productBookingData?.needSamagri === "yes"
  //     ? parseFloat(location?.state?.PAT_SAMAGRIPRICE) +
  //     parseFloat(location?.state?.SamagriPriceTaxAmount)
  //     : 0;
  let samagriPrice = 0;
  if (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes") {
    samagriPrice = samagriPrice + ((Number(location.state?.WetSamagriPrice) +
      Number(location.state?.WetSamagriPriceTaxAmount)) + (Number(location.state?.DrySamagriprice) +
        Number(location.state?.DrySamagriPriceTaxAmount)))
  } else if (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no") {
    samagriPrice = samagriPrice + (Number(location.state?.WetSamagriPrice) +
      Number(location.state?.WetSamagriPriceTaxAmount))
  } else if (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes") {
    samagriPrice = samagriPrice + (Number(location.state?.DrySamagriprice) +
      Number(location.state?.DrySamagriPriceTaxAmount))
  }

  const convenienceFeeFinal =
    parseFloat(location?.state?.PAT_CONVENIENCEFEE) +
    parseFloat(location?.state?.ConvinienceFeeTaxAmount) || 0;
  const tax = parseFloat(DynamicTax) || 0;
  // Final total calculation (ensuring proper addition)
  const FinaltotalPrice = brahminDakshina + samagriPrice + convenienceFeeFinal;
  console.log("prices ", brahminDakshina, samagriPrice, convenienceFeeFinal, FinaltotalPrice);

  const handleRazorpayPayment = async () => {
    let orderIDReturned = null
    let minPayableAmount = modelRequestData.amountEntered
      ? modelRequestData.amountEntered
      : Math.round(grandTotal);

    const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)
    console.log('PlaceOrderResponse', PlaceOrderResponse)
    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/PoojaAtTemple`, {
          BramhanDakshina: location.state.PAT_PRICE,
          PATB_ID: location.state.PATB_ID,
          PAT_ID: location.state.PAT_ID,
          USER_ID: userID,
          TOTAL_PRICE: grandTotal,
          CONVIENCE_FEE: location?.state?.PAT_CONVENIENCEFEE,
          PANDIT_ID: selectedPandit,
          PATB_ADDRESS: location.state.PAT_ADDRESS,
          PATB_LANG: productBookingData?.languageID,
          PATB_DATE: productBookingData.PATB_DATE,
          PATB_TIME: productBookingData.PATB_TIME,
          REFERAL_NO: "",
          PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
          TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
          TRANSACTION_AMT: minPayableAmount,
          PAYMENT_STATUS: "",
          PAT_SAMAGRIPRICE: productBookingData?.needSamagri === "yes"
            ? Math.round(Number(location?.state?.PAT_SAMAGRIPRICE))
            : 0,
          PAT_SAMAGRI: location.state.PAT_SAMAGRI,
          PAT_TaxPercentage: "",
          PAT_TaxAmount: Tax,
          TRANSACTION_AMT: minPayableAmount,
          SamagriPriceTaxAmount: location?.state?.SamagriPriceTaxAmount,
          ConvinienceFeeTaxAmount: location?.state?.ConvinienceFeeTaxAmount,
          SamagriPriceTaxPercent: location?.state?.SamagriPriceTaxPercent,
          ConvinienceFeeTaxPercent:
            location?.state?.ConvinienceFeeTaxPercent,
          CouponCodeID: appliedCoupon?.couponCodeID,
          CouponCodeAmount: appliedCoupon?.CoupenAmount,
          WalletAmount: appliedCoupon?.walletAmount,
          DrySamagriprice: productBookingData?.needDrySamagri === 'yes' ? Number(location?.state?.DrySamagriprice) : 0,
          WetSamagriPrice: productBookingData?.needWetSamagri === 'yes' ? Number(location?.state?.WetSamagriPrice) : 0,
          WetSamagriPriceTaxPercent: location?.state?.WetSamagriPriceTaxPercent,
          DrySamagriPriceTaxPercent: location?.state?.DrySamagriPriceTaxPercent,
          NeedDrySamagri: productBookingData?.needDrySamagri,
          NeedWetSamagri: productBookingData?.needWetSamagri,
          DrySamagriPriceTaxAmount: Number(location?.state?.DrySamagriPriceTaxAmount),
          WetSamagriPriceTaxAmount: Number(location?.state?.WetSamagriPriceTaxAmount)
        })
        .then((res) => {
          if (res) {
            console.log(res);
            setOrderID(res.data.ID);
            setShowCODModal(false);

            orderIDReturned = res.data.ID;
            setLoader(false)
            navigate("/thank-you", {
              state: { moduleName: "PujaAtTemple" },
            });
          }
        });


    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }
  };

  const handlePhonePayPayment = () => {
    const PhonePayOption = {
      UserID: userID,
      MobileNumber: "",
      ModalName: "pujaAtTempleBooking",
      Amount: Math.round(grandTotal),
    };

    const pujaAtTempleBookingData = {
      BramhanDakshina: location.state.PAT_PRICE,
      PATB_ID: location.state.PATB_ID,
      PAT_ID: location.state.PAT_ID,
      USER_ID: userID,
      TOTAL_PRICE: grandTotal,
      CONVIENCE_FEE: convenienceFeeFinal,
      PANDIT_ID: selectedPandit,
      PATB_ADDRESS: location.state.PAT_ADDRESS,
      PATB_LANG: productBookingData?.languageID,
      PATB_DATE: productBookingData.PATB_DATE,
      PATB_TIME: productBookingData.PATB_TIME,
      REFERAL_NO: "",
      PAYMENT_TYPE: "ONLINE",
      // TRANSACTION_ID: paymentId,
      TRANSACTION_AMT: grandTotal,
      PAYMENT_STATUS: "",
      PAT_SAMAGRIPRICE: samagriPrice,
      PAT_SAMAGRI: location.state.PAT_SAMAGRI,
      PAT_TaxPercentage: "",
      PAT_TaxAmount: Tax,
      TRANSACTION_AMT: grandTotal,
      SamagriPriceTaxAmount: location?.state?.SamagriPriceTaxAmount || 0,
      ConvinienceFeeTaxAmount: location?.state?.ConvinienceFeeTaxAmount || 0,
      SamagriPriceTaxPercent: location?.state?.SamagriPriceTaxPercent || 0,
      ConvinienceFeeTaxPercent: location?.state?.ConvinienceFeeTaxPercent || 0,
    };

    axios
      .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
      .then((res) => {
        if (res?.data?.success) {
          console.log("PhonePe Response:", res.data);

          // Use navigate with state instead of window.location.href
          localStorage.setItem(
            "pujaAtTempleBookingData",
            JSON.stringify(pujaAtTempleBookingData)
          );

          window.location.href = res.data.redirectUrl;
        } else {
          console.error("PhonePe Payment Failed:", res.data);
          alert("Something went wrong while creating the payment link.");
        }
      })
      .catch((error) => {
        console.error("PhonePe API Error:", error);
        alert("Failed to initiate PhonePe payment. Please try again.");
      });
  };
  // saurbh tested Api
  const handleRazorpayPaymentSaurabh = () => {
    // debugger;
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    let minPayableAmount = modelRequestData.amountEntered
      ? modelRequestData.amountEntered
      : Number(grandTotal);

    let orderIDReturned = null;

    // axios
    //   .post(`${BaseUrl}/BookPooja`, {
    //     PB_DATE: productBookingData.date,
    //     PB_TIME: productBookingData.time,
    //     PB_LANGAUGE: SelectLanguageOptions.find(
    //       (item) => item.value === productBookingData.languageID
    //     )?.label,
    //     PB_SAMAGRI: productBookingData.needSamagri,
    //     PB_PRICE: pujaDetails?.pujaPrice,
    //     PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
    //     PANDIT_ID: findPandit === true ? null : selectedPandit,
    //     USER_ID: userID,
    //     REFERENCES_NO: "",
    //     ADDRESS: productBookingData?.address,
    //     PUJA_ID: pujaDetails?.pujaId,
    //     PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
    //     CONVINIENCE_FEE: pujaDetails?.convenienceFee,
    //     TAX: null,
    //     EXTRA: null,
    //     TRANSACTION_ID: "",
    //     TRANSACTION_AMT: "",
    //     // New params
    //     PB_DiscountPercentage: pujaDetails.pujaDiscount,
    //     PB_DiscountAmount: pujaDetails.DiscountAmount,
    //     PB_Total: pujaDetails.pujaPrice,
    //     PB_TaxPercentage: ServiceDiscounts.panditBookingDiscount,
    //     PB_TaxAmount: Tax,
    //     PB_GrandTotal: grandTotal,
    //     PAYMENT_STATUS:
    //       minPayableAmount === totalPrice ? "Completed" : "Pending",
    //     TRANSACTION_STATUS: "Success",
    //   })
    //   .then((res) => {
    //     if (res) {
    //       console.log(res);
    //       setOrderID(res.data.ID);
    //       // localStorage.setItem("orderID", JSON.stringify(res.data.ID));
    //       orderIDReturned = res.data.ID;
    //     }
    //   });

    const options = {
      key: RazorPayKey,
      key_secret: RazorPaySecretKey,
      amount: minPayableAmount * 100,
      currency: "INR",
      name: RazorPayName,
      description: "working",
      image: Mylogo,
      handler: function (response) {
        // console.log(response, "Payment Success");
        const paymentId = response.razorpay_payment_id;

        console.log(response, "sfsdf");

        if (response) {
          // axios
          //   .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=Pandit`, {
          //     USER_ID: userID,
          //     ORDER_ID: orderIDReturned,
          //     // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
          //     TRANSACTION_ID: paymentId,
          //     PAYMENT_STATUS:
          //       minPayableAmount === totalPrice ? "Completed" : "Pending",
          //     TRANSACTION_STATUS: "Success",
          //     TRANSACTION_AMT: minPayableAmount,
          //     REMAING_AMOUNT:
          //       Number(totalPrice) +
          //       Number(pujaDetails?.pujaSamagriPrice) +
          //       Number(pujaDetails?.convenienceFee) -
          //       minPayableAmount,
          //     PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
          //   })
          //   .then((res) => {
          //     // debugger;
          //     if (res.data.ResponseMessage === "successfully.") {
          //       // localStorage.setItem("cartItemCount", "0");
          //       // window.dispatchEvent(new Event("cartUpdated"));
          //       setShowCODModal(false);
          //       nextStep();
          //     } else {
          //       alert("Order placement failed, please try again.");
          //     }
          //   });
          axios
            .post(`${BaseUrl}/BookPooja`, {
              PB_DATE: productBookingData.date,
              PB_TIME: productBookingData.time,
              PB_LANGAUGE: SelectLanguageOptions.find(
                (item) => item.value === productBookingData.languageID
              )?.label,
              PB_SAMAGRI: productBookingData.needSamagri,
              PB_PRICE: pujaDetails?.pujaPrice,
              PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
              PANDIT_ID: findPandit === true ? null : selectedPandit,
              USER_ID: userID,
              REFERENCES_NO: "",
              ADDRESS: productBookingData?.address,
              PUJA_ID: pujaDetails?.pujaId,
              PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
              CONVINIENCE_FEE: pujaDetails?.convenienceFee,
              TAX: null,
              EXTRA: null,
              TRANSACTION_ID: paymentId,
              TRANSACTION_AMT: grandTotal,
              // New params
              PB_DiscountPercentage: pujaDetails.pujaDiscount,
              PB_DiscountAmount: pujaDetails.DiscountAmount,
              PB_Total: pujaDetails.pujaPrice,
              PB_TaxPercentage: ServiceDiscounts.panditBookingDiscount,
              PB_TaxAmount: Tax,
              PB_GrandTotal: grandTotal,
              PAYMENT_STATUS:
                minPayableAmount === totalPrice ? "Completed" : "Pending",
              TRANSACTION_STATUS: "Success",
            })
            .then((res) => {
              if (res) {
                console.log(res);
                setOrderID(res.data.ID);
                setShowCODModal(false);
                nextStep();
                // localStorage.setItem("orderID", JSON.stringify(res.data.ID));
                orderIDReturned = res.data.ID;
              }
            });
        }

        // const updatedPayload = {
        //   ...razorPayData,
        //   TRANSACTION_ID: paymentId,
        //   TRANSACTION_AMT: minPayableAmount,
        // };

        // axios.post(`${BaseUrl}/BookPooja`, updatedPayload).then((res) => {
        //   debugger;
        //   if (res.data.ResponseMessage === "Order Success.") {
        //     localStorage.setItem("cartItemCount", "0");
        //     window.dispatchEvent(new Event("cartUpdated"));
        //     navigate("/thank-you");
        //   } else {
        //     alert("Order placement failed, please try again.");
        //   }
        // });
      },
      theme: {
        color: "#ff416c",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handlePanditSelectionNext = () => {
    // debugger;
    if (
      selectedPandit !== null &&
      selectedPandit !== undefined &&
      selectedPandit !== ""
    ) {
      // console.log("Panditselection");
      nextStep();
    } else {
      setPanditSelectionError(true);
    }
  };

  const handleToDateChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue).format("YYYY-MM-DD");
      setProductBookingData((prev) => ({ ...prev, PATB_DATE: newToDate }));
    } else {
      setProductBookingData((prev) => ({ ...prev, PATB_DATE: null }));
    }
  };

  const handleLanguageChange = (selectedValue) => {
    setProductBookingData((prev) => ({
      ...prev,
      languageID: selectedValue.value,
    }));
  };

  const handlePanditCardClicked = (pandit) => {
    setSelectedPandit(pandit.PANDIT_ID);
    // console.log(pandit);
  };

  const handleCODClicked = () => {
    setModelRequestData((prev) => ({
      ...prev,
      totalPrice: totalPrice,
    }));
    setShowCODModal(true);
  };

  console.log(totalPrice);

  const handleFindPandit = () => {
    setFindPandit(true);
    nextStep();
  };

  const Tax = Math.round(
    (ServiceDiscounts.PujaAtTemple / 100) * Number(FinaltotalPrice)
  );
  const grandTotal = Math.round(parseFloat(FinaltotalPrice - couponAmount || 0));


  const handleOpenCoupenModal = () => {

    setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
    setShowModal(true)
  }

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  function convertTo12Hour(time24) {
    if (typeof time24 !== "string" || !time24.includes(":")) {
      return ""; // or return time24; or handle invalid input however you'd like
    }

    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";

    hour = hour % 12;
    hour = hour === 0 ? 12 : hour;

    return `${hour.toString().padStart(2, "0")}:${minute} ${ampm}`;
  }




  console.log('productBookingData', convertTo12Hour(productBookingData.PATB_TIME))
  return (
    <div style={{ background: "#F1F6F7", paddingTop: "30px" }}>
      {/* Step Indicator */}
      <div className="stepper-wrapper">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`stepper-item ${index < currentStep
              ? "completed"
              : index === currentStep
                ? "active"
                : ""
              }`}
          >
            <div className="step-counter">{index + 1}</div>
            <div className="step-name" style={{ fontSize: "small" }}>
              {step}
            </div>
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div
        className="step-content"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "10px 30px",
          background: "#F1F6F7",
        }}
      >
        {currentStep === 0 && (
          <>
            <div className="booking-details-container ">
              <div
                className="booking-details-left"
              // style={{
              //   padding: "10px 20px",
              //   display: "flex",
              //   alignItems: "center",
              //   justifyContent: "center",
              // }}
              >
                <h5>Booking Details</h5>
                <hr />
                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="bookingDate" style={{ textAlign: "left" }}>
                      Date<span style={{ color: "red" }}>*</span>
                    </label>
                    <DatePicker
                      id="bookingDate"
                      value={productBookingData?.PATB_DATE || ""}
                      minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
                      clearIcon={null}
                      onChange={handleToDateChange}
                      format="dd/MM/yyyy"
                      className="custom-date-picker"
                    />
                    {error && !productBookingData.PATB_DATE && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                      Time<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      id="bookingTime"
                      type="time"
                      className="custom-form-control"
                      value={productBookingData.PATB_TIME || ""}
                      onClick={(e) =>
                        e.target.showPicker && e.target.showPicker()
                      }
                      onChange={(e) =>
                        setProductBookingData((prev) => ({
                          ...prev,
                          PATB_TIME: e.target.value,
                        }))
                      }
                    />
                    {error && !productBookingData.PATB_TIME && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="language" style={{ textAlign: "left" }}>
                      Select Language<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      styles={customSelectStyles}
                      options={languageList}
                      onChange={handleLanguageChange}
                      value={languageList.find(
                        (item) => item.value === productBookingData.languageID
                      )}

                    />
                    {error && !productBookingData.languageID && (
                      <span className="error-msg">{ERROR_MESSAGES}</span>
                    )}
                  </div>{" "}
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column"></div>{" "}
                </div>
                <div >
                  Do you want Samagri for this Puja?
                </div>
                <div className="row mb-3">
                  {/* Wet Samagri */}
                  {Number(location?.state?.WetSamagriPrice) > 0 && (
                    <div className="col-md-6 col-sm-12 d-flex align-items-center">
                      <label className="fw-semibold me-2 mb-0">Wet Samagri:</label>
                      <div className="d-flex align-items-center">
                        <label className="me-3 mb-0">
                          <input
                            type="radio"
                            name="wetSamagri"
                            value="yes"
                            checked={productBookingData.needWetSamagri === "yes"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needWetSamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          Yes
                        </label>
                        <label className="mb-0">
                          <input
                            type="radio"
                            name="wetSamagri"
                            value="no"
                            checked={productBookingData.needWetSamagri === "no"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needWetSamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          No
                        </label>
                      </div>
                    </div>
                  )}


                  {/* Dry Samagri */}
                  {Number(location?.state?.DrySamagriprice) > 0 && (
                    <div className="col-md-6 col-sm-12 d-flex align-items-center">
                      <label className="fw-semibold me-2 mb-0">Dry Samagri:</label>
                      <div className="d-flex align-items-center">
                        <label className="me-3 mb-0">
                          <input
                            type="radio"
                            name="drySamagri"
                            value="yes"
                            checked={productBookingData?.needDrySamagri === "yes"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needDrySamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          Yes
                        </label>
                        <label className="mb-0">
                          <input
                            type="radio"
                            name="drySamagri"
                            value="no"
                            checked={productBookingData.needDrySamagri === "no"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needDrySamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          No
                        </label>
                      </div>
                    </div>
                  )}

                </div>

                {/* Price Message Centered */}
                <div className="row">
                  <div className="col-12 d-flex justify-content-center">
                    <div
                      style={{
                        background: "linear-gradient(90deg, #eeb11a, #a52444)",
                        padding: "5px 15px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "white",
                        minWidth: "320px",
                        fontSize: '16px'
                      }}
                    >
                      {productBookingData?.needWetSamagri === "yes" &&
                        productBookingData?.needDrySamagri === "yes" ? (
                        <>
                          Samagri Amount: ₹{" "}
                          {formatToIndianCurrency(
                            (Number(location.state?.DrySamagriprice || 0) +
                              Number(location.state?.WetSamagriPrice || 0))
                          )}
                        </>
                      ) : productBookingData?.needWetSamagri === "yes" ? (
                        <>
                          Wet Samagri Amount: ₹{" "}
                          {formatToIndianCurrency(location.state?.WetSamagriPrice || 0)}
                        </>
                      ) : productBookingData?.needDrySamagri === "yes" ? (
                        <>
                          Dry Samagri Amount: ₹{" "}
                          {formatToIndianCurrency(location.state?.DrySamagriprice || 0)}
                        </>
                      ) : (
                        <>All puja samagri will arrange by you  </>
                      )}

                    </div>
                  </div>
                </div>
              </div>
              <div className=" booking-details-right">
                <div className="price-summary">
                  <h5>{location?.state?.PAT_NAME}</h5>
                  <hr />
                  <ul>
                    <li>
                      <span>
                        {/* Collected on behalf of pandit <br></br> & paid to pandit: */}
                        Puja Price (₹) :
                      </span>
                      <span>
                        {/* <br></br> */}
                        {location.state.PAT_PRICE}
                      </span>
                    </li>
                    <hr></hr>
                    {(productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes")
                      ?
                      (
                        <>
                          <li>
                            <span>Samagri Price (₹):</span>
                            <span>
                              {formatToIndianCurrency((Number(location.state?.WetSamagriPrice) +
                                Number(location.state?.WetSamagriPriceTaxAmount)) + (Number(location.state?.DrySamagriprice) +
                                  Number(location.state?.DrySamagriPriceTaxAmount)))}

                            </span>
                          </li>
                          <hr></hr>
                        </>
                      )
                      : (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no")
                        ?
                        (
                          <>
                            <li>
                              <span> Wet Samagri Price (₹):</span>
                              <span>
                                {formatToIndianCurrency(
                                  (Number(location.state?.WetSamagriPrice) +
                                    Number(location.state?.WetSamagriPriceTaxAmount))
                                )}

                              </span>
                            </li>
                            <hr></hr>
                          </>
                        ) : (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes")
                          ?
                          (
                            <>
                              <li>
                                <span> Dry Samagri Price (₹):</span>
                                <span>
                                  {formatToIndianCurrency(
                                    Number(location.state?.DrySamagriprice) +
                                    Number(location.state?.DrySamagriPriceTaxAmount)
                                  )}

                                </span>
                              </li>
                              <hr></hr>
                            </>
                          ) : ''
                    }

                    <li>
                      <span>Convenience Fee (₹):</span>
                      <span>

                        {Math.round(
                          Number(location.state.PAT_CONVENIENCEFEE) +
                          Number(location.state?.ConvinienceFeeTaxAmount)
                        ) || 0}
                      </span>
                    </li>
                    {/* <li>
                      <span> Convenience  Tax ({location.state?.ConvinienceFeeTaxPercent}%):</span>
                      <span>Rs {Math.round(location.state?.ConvinienceFeeTaxAmount)}</span>
                    </li> */}
                    <hr />

                    <li>
                      <span>Grand Total (₹):</span>
                      <span>  {Math.round(grandTotal)}</span>
                    </li>
                  </ul>
                  {/* <p>Payment Type: COD</p>
                <button className="place-order-btn">Place Order</button> */}
                </div>
              </div>
            </div>

          </>
        )}

        {/* {currentStep === 1 && (
          <div className="panditList" style={{ width: "100%" }}>
            <div className="container">
              <div className="row mb-4">
                <div className="col-md-12 px-lg-5">

                  <div className="padit-list-products mt-3">
                    <div className="row">
                      {panditDataList?.map((pandit) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
                          key={pandit.PANDIT_ID}
                        >
                          <div
                            className={`card pandit-card ${selectedPandit === pandit.PANDIT_ID
                              ? "selected"
                              : ""
                              }`}
                            onClick={() => handlePanditCardClicked(pandit)}
                          >
                            <div
                              className="card-img-container"
                              style={{ padding: "10px", objectFit: "cover" }}
                            >
                              <img
                                src={pandit.PHOTO}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = placeholderImg;
                                }}
                                alt={pandit.PANDIT_NAME}
                                className="card-img-top"
                              />
                            </div>

                            <div className="card-body text-center">
                              <h5 className="card-title">
                                {pandit.PANDIT_NAME}
                              </h5>
                              <p className="card-text">
                                <strong>Mobile:</strong> {pandit.MOBILE_NO}
                              </p>
                              <p className="card-text">
                                <strong>Experience:</strong> {pandit.EXPERIENCE}{" "}
                                years
                              </p>
                              <p className="card-text">
                                <strong>DOB:</strong>{" "}
                                {new Date(pandit.DOB).toLocaleDateString()}
                              </p>

                              <div className="rating">
                                {renderStarRating(
                                  parseFloat(pandit.PANDIT_RATING)
                                )}
                                <span className="rating-text">
                                  ({pandit.PANDIT_RATING})
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    {panditSelectionError &&
                      (selectedPandit === null ||
                        selectedPandit === undefined ||
                        selectedPandit === "") ? (
                      <span style={{ color: "red" }}>Please Select Pandit</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <span className="text-center">
                  {" "}
                  Didn't find a pandit you like?
                  <span
                    onClick={handleFindPandit}
                    style={{ color: "#a42642", cursor: "pointer" }}
                  >
                    {" "}
                    Click here, and we will find one for you.
                  </span>
                </span>
              </div>
            </div>
          </div>
        )} */}

        {currentStep === 1 && (
          <div className="py-4" style={{ width: "100%" }}>
            <div className="p-3">
              <div className="row g-4 d-flex">
                <div
                  className="booking-preview col-md-5 text-center"
                  style={{
                    flex: "2",
                  }}
                >
                  <div className="booking-preview-details-puja d-flex">

                    <div className="booking-preview-details-puja-top-left" style={{ marginRight: '2em', width: 'auto' }}>
                      <img
                        src={location?.state?.PAT_IMAGE}
                        className="img-fluid "
                        style={{
                          width: "280px",
                          height: "180px",
                          objectFit: "cover",
                        }}
                        alt=""
                      />
                    </div>
                    <div >
                      <h4 className="fw-bold " >
                        {location?.state?.PAT_NAME}
                      </h4>
                      <hr />
                      <p className="text-start mb-1">
                        <strong>Booking Language:</strong> {" "}
                        {
                          languageList.filter(
                            (item) =>
                              item.value === productBookingData.languageID
                          )[0]?.label
                        }
                      </p>
                      <p className="mb-1 text-start">
                        <strong>Booking Date:</strong>   {dayjs(productBookingData.PATB_DATE).format('DD/MM/YYYY')}
                      </p>
                      <p className="mb-1 text-start">
                        <strong>Booking Time:</strong>    {convertTo12Hour(productBookingData.PATB_TIME)}
                      </p>
                      {/* <span>
                          Pandit Name:{" "}
                          {
                            panditDataList.filter(
                              (item) => item.PANDIT_ID === selectedPandit
                            )[0]?.PANDIT_NAME
                          }
                        </span> */}
                      <p className="fw-bold">
                        Note : You will receive pandit details within 24 hours
                      </p>
                    </div>

                  </div>
                </div>
                <div className=" booking-details-right">
                  <div className="price-summary">
                    <h4>Price Details</h4>
                    <hr />
                    <ul>
                      <li>
                        {appliedCoupon?.isApplied ? (
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                              <span>Applied Coupon</span>
                              {appliedCoupon && (
                                <>
                                  <span
                                    style={{
                                      border: '1px dotted #333',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      backgroundColor: '#fff',
                                      color: '#333',
                                      marginLeft: '6px',
                                    }}
                                  >
                                    {appliedCoupon?.CouponCode}
                                  </span>

                                </>


                              )}
                            </div>
                            <span
                              onClick={() => {
                                setAppliedCoupon((prev) => ({
                                  ...prev, CouponCode: null,
                                  isApplied: false,
                                  CoupenAmount: 0,
                                  walletAmount: 0
                                }))
                              }}
                              style={{
                                // border: '1px dotted #333',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                backgroundColor: '#fff',
                                color: '#a52444',
                                marginLeft: '6px',
                              }} >



                              Remove

                            </span>
                            <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                          </div>
                        ) : (
                          <div
                            onClick={() => setShowModal(true)}
                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{
                                backgroundColor: '#a52444',
                                color: 'white',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                marginRight: '10px',

                              }}>
                                %
                              </div>
                              <span style={{ fontWeight: '400' }}>View Coupons & Offers</span>

                            </div>
                            <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span>
                          </div>
                        )}

                      </li>
                      {walletAmount > 0 && (
                        <li style={{ fontSize: 'smaller', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              // cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '16px', cursor: 'pointer', width: '100%' }}>
                                <input
                                  type="checkbox"
                                  checked={isWalletApplied}
                                  onChange={(e) => {
                                    setAppliedCoupon((PREV) => ({
                                      ...PREV, CouponCode: null,
                                      isApplied: false
                                    }))
                                    setIsWalletApplied(e.target.checked)
                                  }
                                  }

                                  style={{ cursor: 'pointer' }}
                                />
                                Available wallet amount (₹) {walletAmount}
                              </label>
                            </div>
                            {/* <div className="d-flex justify-content-center">

                              <small>(Upto 50% can be applied)</small>
                            </div> */}
                            {/* <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span> */}
                          </div>

                        </li>
                      )}

                      <hr></hr>
                      <li>
                        <span>
                          {/* Collected on behalf of pandit <br></br> & paid to pandit: */}
                          Puja Price (₹) :
                        </span>
                        <span>
                          {/* <br></br> */}
                          {location.state.PAT_PRICE}
                        </span>
                      </li>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Wallet Amount (₹)

                          </span>
                          <span>
                            {appliedCoupon?.walletAmount}
                          </span>
                        </li>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Coupon  Amount (₹)

                          </span>
                          <span>
                            {couponAmount}
                          </span>
                        </li>
                      ) : ''}
                      <hr></hr>
                      {(productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes")
                        ?
                        (
                          <>
                            <li>
                              <span>Samagri Price (₹):</span>
                              <span>
                                {formatToIndianCurrency((Number(location?.state?.WetSamagriPrice) +
                                  Number(location?.state?.WetSamagriPriceTaxAmount)) + (Number(location?.state?.DrySamagriprice) +
                                    Number(location?.state?.DrySamagriPriceTaxAmount)))}

                              </span>
                            </li>
                            <hr></hr>
                          </>
                        )
                        : (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no")
                          ?
                          (
                            <>
                              <li>
                                <span> Wet Samagri Price (₹):</span>
                                <span>
                                  {formatToIndianCurrency(
                                    (Number(location?.state?.WetSamagriPrice) +
                                      Number(location?.state?.WetSamagriPriceTaxAmount))
                                  )}

                                </span>
                              </li>
                              <hr></hr>
                            </>
                          ) : (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes")
                            ?
                            (
                              <>
                                <li>
                                  <span> Dry Samagri Price (₹) :</span>
                                  <span>
                                    {formatToIndianCurrency(
                                      Number(location?.state?.DrySamagriprice) +
                                      Number(location?.state?.DrySamagriPriceTaxAmount)
                                    )}

                                  </span>
                                </li>
                                <hr></hr>
                              </>
                            ) : ''
                      }



                      <li>
                        <span>Convenience Fee (₹) :</span>
                        <span>
                          Rs{" "}
                          {Math.round(
                            Number(location.state.PAT_CONVENIENCEFEE) +
                            Number(location.state?.ConvinienceFeeTaxAmount)
                          ) || 0}
                        </span>
                      </li>
                      {/* <li>
                      <span> Convenience  Tax ({location.state?.ConvinienceFeeTaxPercent}%):</span>
                      <span>Rs {Math.round(location.state?.ConvinienceFeeTaxAmount)}</span>
                    </li> */}
                      <hr />

                      <li>
                        <span>Grand Total (₹) :</span>
                        <span> Rs {Math.round(grandTotal)}</span>
                      </li>
                    </ul>
                    <div className="mt-3 d-flex justify-content-end gap-2">
                      {/* <button
                        style={{ backgroundColor: "#a53444", color: "white" }}
                        className="btn px-4"
                        onClick={handleCODClicked}
                      >
                        Cash On Delivery
                      </button> */}
                      <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handleRazorpayPayment}
                      >
                        Pay
                      </button>
                      {/* <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handlePhonePayPayment}
                      >
                        Phone Pay
                      </button> */}
                    </div>
                    {/* <p>Payment Type: COD</p>
                <button className="place-order-btn">Place Order</button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div>
            <div className="carousel-inner" role="listbox">
              <div className="item carousel-item-four active">
                <div className="">
                  <div className="row">
                    <div className="carousel slide carousel-slider">
                      <div className="carousel-position-four">
                        <div className="carousel-inner">
                          <div
                            className="banner-breadcrumb"
                            style={{
                              // backgroundImage: `url(${StupaImg})`,
                              width: "100%",
                              // height: "100px",
                            }}

                          // style={{ backgroundImage: `url(${AboutImg})` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="error-404">
              <div>
                <img
                  src={placeholderImg}
                  alt="404"
                  className="error-404__image"
                />
              </div>

              <h3 className="error-404__text">Thank you for your order! </h3>
              <div className="error-404__btns"></div>
            </div>
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      {
        currentStep === 0 ? (
          <div

            style={{ display: 'flex', marginRight: "50px", paddingBottom: "30px", justifyContent: 'flex-end' }}
          >
            {/* <button
          onClick={prevStep}
          disabled={currentStep === 0}
          className="btn btn-secondary"
          style={{ backgroundColor: "#d7d7d7", color: "black" }}
        >
          Previous
        </button> */}
            <button
              onClick={
                currentStep === 0
                  ? HandleProductBookingBtnClicked
                  : currentStep === 1
                    ? handlePanditSelectionNext
                    : ""
              }
              disabled={currentStep === steps.length - 1}
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px" }}
            >
              Next
            </button>
          </div>
        ) : currentStep === 1 ? (
          <div
            className="navigation-buttons"
            style={{ marginRight: "50px", paddingBottom: "30px" }}
          >
            <button
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px" }}
              onClick={prevStep}
            >
              Previous
            </button>
          </div>
        ) : currentStep === 2 ? (
          <div
            className="navigation-buttons"
            style={{ marginRight: "50px", paddingBottom: "30px" }}
          >
            <button className=" prev-btn" onClick={() => navigate("/")}>
              Home
            </button>
            <button
              className=" prev-btn"
              onClick={() => navigate("/my-order-puja-At-Temple")}
            >
              My Orders
            </button>
          </div>
        ) : (
          <div
            className="navigation-buttons"
            style={{ marginRight: "50px", paddingBottom: "30px", justifyContent: 'flex-end' }}
          >
            <button
              onClick={prevStep}
              disabled={currentStep === 0}
              className="btn btn-secondary"
              style={{ backgroundColor: "#d7d7d7", color: "black" }}
            >
              Previous
            </button>
            <button
              onClick={
                currentStep === 0
                  ? HandleProductBookingBtnClicked
                  : currentStep === 1
                    ? handlePanditSelectionNext
                    : ""
              }
              disabled={currentStep === steps.length - 1}
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px" }}
            >
              Next
            </button>
          </div>
        )
      }
      {/* <CODModal
        show={showCODModal}
        onHide={() => setShowCODModal(false)}
        onConfirm={handleRazorpayPayment}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
      /> */}
      <CouponModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelRequestData={modelRequestData}
        setAppliedCoupon={setAppliedCoupon}
        setIsWalletApplied={setIsWalletApplied}
        apiParam={couponObj} />
    </div >
  );
};

export default PujaAtTempleBookingForm;
